import { useState, useEffect } from "react";
import useMediaQuery from "./useMediaQuery";
import * as Const from "./../_Const";

export default function useScreenType() {
  const [screenType, setScreenType] = useState(Const.SCREEN_UNKNOWN);
  //mam 3 velikosti obrazovek pro terminal
  //1280x800 waveshare 10.1 HDMI
  //1280x800 waveshare 10.1 LCD dle rpi shopu je mozna jen 1200x800 - ale nebudu ho pouzivat
  //1280x720 RPI V2 DSI
  //800x480 RPI V1 DSI
  const sc480 = useMediaQuery("(min-height: 480px)");
  const sc720 = useMediaQuery("(min-height: 720px)");
  const sc800 = useMediaQuery("(min-height: 800px)");

  let screenVal = Const.SCREEN_UNKNOWN;
  if (Const.isTerminal()) {
    if (sc800) {
      screenVal = Const.SCREEN_WAVESHARE;
    } else if (sc720) {
      screenVal = Const.SCREEN_RPIV2;
    } else if (sc480) {
      screenVal = Const.SCREEN_RPIV1;
    }
  } else {
    screenVal = Const.SCREEN_PHONE;
  }

  useEffect(() => {
    setScreenType(screenVal);
    //console.log("set screen:", screenVal);
  }, [screenVal]);

  return screenType;
}
